import { RestService } from './rest.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from './session.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class VeiculoService extends RestService {

  constructor(protected http: HttpClient,
    protected session: SessionService,
    protected router: Router
  ) {
    super(http, session, router);
  }


  getPlacas(placa): any {
    let postData = { "placa": placa }
    return this.http.post(this.ws + "wsConsultaPlaca.rule?sys=API", JSON.stringify(postData)
    )
  }

  getOrcamentos(postData): any {
    return this.http.post(this.ws + "wsOrcamentos.rule?sys=API", postData)
  }

  getMarcas(): any {
    let postData = {}
    return this.http.post(this.ws + "wsMarcas.rule?sys=API", JSON.stringify(postData))
  }

  getMarca(idMarca = null): any {
    let postData = {}
    if (idMarca) {
      postData['valor'] = idMarca;
    }
    return this.http.post(this.ws + "wsMarcas.rule?sys=API", JSON.stringify(postData))
  }

  getGeracao(idGeracao = null): any {
    let postData = {}
    if (idGeracao) {
      postData['valor'] = idGeracao;
    }
    return this.http.post(this.ws + "wsGeracao.rule?sys=API", JSON.stringify(postData))
  }

  getModelo(idModelo): any {
    let postData = { "valor": idModelo }
    return this.http.post(this.ws + "wsModelo.rule?sys=API", JSON.stringify(postData))
  }

  getVersao(idVersao): any {
    let postData = { "valor": idVersao }
    return this.http.post(this.ws + "wsVersao.rule?sys=API", JSON.stringify(postData))
  }

  //dentro do veiculo existe um array [groups]
  getVeiculo(idVeiculo): any {
    let postData = { "valor": idVeiculo }
    return this.http.post(this.ws + "wsVeiculo.rule?sys=API", JSON.stringify(postData))
  }

  //dentro do grupo existe um array [subgroups]
  getGrupo(idVeiculo, idGrupo): any {
    let postData = {
      "idVeiculo": idVeiculo,
      "grupo": idGrupo
    }
    return this.http.post(this.ws + "wsConsultaGrupo.rule?sys=API", JSON.stringify(postData)
    )
  }

  //dentro do subgroup existe um array [pecaCiclos]
  getSubgroup(idVeiculo, idSubGrupo): any {
    let postData = {
      "idVeiculo": idVeiculo,
      "subGrupo": idSubGrupo
    }
    return this.http.post(this.ws + "wsSubGrupo.rule?sys=API", JSON.stringify(postData)
    )
  }

  //dentro do subgroup existe um array [pecaCiclos]
  getPecas(idGrupo, idSubGrupo): any {
    let postData = {
      "grupo": idGrupo,
      "subGrupo": idSubGrupo
    }
    return this.http.post(this.ws + "wsConsultaPeca.rule?sys=API", JSON.stringify(postData)
    )
  }

}

